/**
 * MK Custom Cart Line Recommendations
 *
 * Loads and renders product recommendations belonging to each
 * individual cart line.
 */

(function () {
  'use strict';

  const MODULE_SELECTOR = '[data-mkcustom-cart-line-rec]';
  const SOURCE_SELECTOR = '[data-mkcustom-cart-line-rec-source]';
  const GRID_SELECTOR = '[data-mkcustom-cart-line-rec-grid]';

  const QUICK_VIEW_MODAL_SELECTOR =
  '[data-mkcustom-cart-quick-view]';

  const QUICK_VIEW_OPEN_CLASS =
  'mkcustom-cart-quick-view-open';

  function normalizeSku(sku) {
    return String(sku || '')
      .trim()
      .toLowerCase();
  }

  function splitSkus(value) {
    if (Array.isArray(value)) {
      return value
        .map(function (sku) {
          return String(sku || '').trim();
        })
        .filter(Boolean);
    }

    if (value === null || value === undefined) {
      return [];
    }

    return String(value)
      .split(/[\n,]+/)
      .map(function (sku) {
        return sku.trim();
      })
      .filter(Boolean);
  }

  function readModuleData(module) {
    const source = module.querySelector(SOURCE_SELECTOR);

    if (!source) {
      return null;
    }

    try {
      return JSON.parse(source.textContent);
    } catch (error) {
      console.error(
        'MK Cart Line Recommendations: Invalid JSON.',
        error
      );

      return null;
    }
  }

  function buildCandidateSkus(data) {
    const cartSkus = new Set(
      (data.cartSkus || [])
        .map(normalizeSku)
        .filter(Boolean)
    );

    const seen = new Set();

    return splitSkus(data.recommendedSkus)
      .filter(function (sku) {
        const normalized = normalizeSku(sku);

        if (!normalized) {
          return false;
        }

        if (cartSkus.has(normalized)) {
          return false;
        }

        if (seen.has(normalized)) {
          return false;
        }

        seen.add(normalized);

        return true;
      })
      .slice(0, 24);
  }

  function fetchProductBySku(sku) {
    const url =
      '/search?q=' +
      encodeURIComponent(sku) +
      '&type=product&view=pdp-rec-json';

    return fetch(url, {
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json'
      }
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error(
            'Product request failed for SKU ' + sku
          );
        }

        return response.json();
      })
      .then(function (data) {
        if (
          !data ||
          !Array.isArray(data.products) ||
          !data.products.length
        ) {
          return null;
        }

        return data.products[0];
      })
      .catch(function (error) {
        console.warn(
          'MK Cart Line Recommendations:',
          error
        );

        return null;
      });
  }

  function createElement(tagName, className, text) {
    const element = document.createElement(tagName);

    if (className) {
      element.className = className;
    }

    if (text !== undefined && text !== null) {
      element.textContent = text;
    }

    return element;
  }
function normalizeProductImages(product) {
  const images = [];
  const seenImages = new Set();

  function getImageKey(imageUrl) {
    return String(imageUrl || '')
      .replace(/^https?:/, '')
      .split('?')[0]

      /*
      * Shopify may return the same image using different
      * generated size suffixes.
      *
      * Example:
      * product.jpg
      * product_1200x.jpg
      * product_800x800.jpg
      *
      * Treat those as the same gallery image.
      */
      .replace(
        /_(?:\d+x\d*|\d*x\d+)(?=\.[a-z0-9]+$)/i,
        ''
      )

      .trim()
      .toLowerCase();
  }

  function addImage(imageUrl) {
    if (!imageUrl) {
      return;
    }

    const normalizedUrl = String(imageUrl).trim();
    const imageKey = getImageKey(normalizedUrl);

    if (!imageKey || seenImages.has(imageKey)) {
      return;
    }

    seenImages.add(imageKey);
    images.push(normalizedUrl);
  }

  /*
   * Add the full product gallery first.
   * This uses the larger 1200px image URLs from the endpoint.
   */
  if (Array.isArray(product.images)) {
    product.images.forEach(function (image) {
      const imageUrl =
        typeof image === 'string'
          ? image
          : image && (image.url || image.src);

      addImage(imageUrl);
    });
  }

  /*
   * Use the featured image only as a fallback if it is not
   * already represented in the product gallery.
   */
  addImage(product.image);

  return images;
}

function normalizeShortDescription(product) {
  const source =
    product.shortDescription ||
    product.short_description ||
    product.shortDescriptionBullets ||
    '';

  if (Array.isArray(source)) {
    return source
      .map(function (item) {
        return String(item || '').trim();
      })
      .filter(Boolean)
      .slice(0, 3);
  }

  const html = String(source || '').trim();

  if (!html) {
    return [];
  }

  const wrapper = document.createElement('div');
  wrapper.innerHTML = html;

  const listItems = Array.from(
    wrapper.querySelectorAll('li')
  )
    .map(function (item) {
      return String(item.textContent || '').trim();
    })
    .filter(Boolean);

  if (listItems.length) {
    return listItems.slice(0, 3);
  }

  return String(wrapper.textContent || '')
    .split(/\r?\n|[•|]+/)
    .map(function (item) {
      return item
        .replace(/^[-–—]\s*/, '')
        .trim();
    })
    .filter(Boolean)
    .slice(0, 3);
}

function calculateSavings(product) {
  const price = Number(product.priceRaw || product.priceAmount || 0);
  const comparePrice = Number(
    product.comparePriceRaw ||
    product.comparePriceAmount ||
    0
  );

  if (
    !product.onSale ||
    !price ||
    !comparePrice ||
    comparePrice <= price
  ) {
    return '';
  }

    const savings = (comparePrice - price) / 100;

    return new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency: product.currency || 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
    }).format(savings);
}

function createQuickViewModal() {
  const existingModal = document.querySelector(
    QUICK_VIEW_MODAL_SELECTOR
  );

  if (existingModal) {
    return existingModal;
  }

  const modal = createElement(
    'div',
    'mkcustom-cart-quick-view'
  );

  modal.hidden = true;
  modal.setAttribute('data-mkcustom-cart-quick-view', '');
  modal.setAttribute('aria-hidden', 'true');

  modal.innerHTML = `
    <div
      class="mkcustom-cart-quick-view__backdrop"
      data-mkcustom-cart-quick-view-close
    ></div>

    <section
      class="mkcustom-cart-quick-view__dialog"
      role="dialog"
      aria-modal="true"
      aria-labelledby="mkcustom-cart-quick-view-title"
    >
      <button
        type="button"
        class="mkcustom-cart-quick-view__close"
        data-mkcustom-cart-quick-view-close
        aria-label="Close product details"
      >
        ×
      </button>

      <div class="mkcustom-cart-quick-view__media">
        <button
          type="button"
          class="mkcustom-cart-quick-view__gallery-control
                 mkcustom-cart-quick-view__gallery-control--previous"
          data-mkcustom-cart-quick-view-previous
          aria-label="Previous product image"
        >
          ‹
        </button>

            <div
            class="mkcustom-cart-quick-view__sale-badge"
            data-mkcustom-cart-quick-view-sale
            >
            SALE
            </div>

            <img
            class="mkcustom-cart-quick-view__image"
            data-mkcustom-cart-quick-view-image
            alt=""
            >

        <button
          type="button"
          class="mkcustom-cart-quick-view__gallery-control
                 mkcustom-cart-quick-view__gallery-control--next"
          data-mkcustom-cart-quick-view-next
          aria-label="Next product image"
        >
          ›
        </button>
      </div>

      <div class="mkcustom-cart-quick-view__content">
        <div
        class="mkcustom-cart-quick-view__brand"
        data-mkcustom-cart-quick-view-brand
        ></div>

        <div
        class="mkcustom-cart-quick-view__sku"
        data-mkcustom-cart-quick-view-sku
        ></div>

        <div
          class="mkcustom-cart-quick-view__stock"
          data-mkcustom-cart-quick-view-stock
        >
          ✓ In Stock
        </div>

        <h2
        id="mkcustom-cart-quick-view-title"
        class="mkcustom-cart-quick-view__title"
        data-mkcustom-cart-quick-view-title
        ></h2>

        <div class="mkcustom-cart-quick-view__pricing">
          <span
            class="mkcustom-cart-quick-view__price"
            data-mkcustom-cart-quick-view-price
          ></span>

          <span
            class="mkcustom-cart-quick-view__compare"
            data-mkcustom-cart-quick-view-compare
          ></span>

          <span
            class="mkcustom-cart-quick-view__savings"
            data-mkcustom-cart-quick-view-savings
          ></span>
        </div>

        <div class="mkcustom-cart-quick-view__divider"></div>

        <ul
          class="mkcustom-cart-quick-view__bullets"
          data-mkcustom-cart-quick-view-bullets
        ></ul>

        <button
          type="button"
          class="mkcustom-cart-quick-view__add"
          data-mkcustom-cart-quick-view-add
        >
          + Add to Cart
        </button>
      </div>
    </section>
  `;

  document.body.appendChild(modal);

  modal
    .querySelectorAll('[data-mkcustom-cart-quick-view-close]')
    .forEach(function (button) {
      button.addEventListener('click', closeQuickView);
    });

  document.addEventListener('keydown', function (event) {
    if (
      event.key === 'Escape' &&
      !modal.hidden
    ) {
      closeQuickView();
    }
  });

  return modal;
}

function closeQuickView() {
  const modal = document.querySelector(
    QUICK_VIEW_MODAL_SELECTOR
  );

  if (!modal) {
    return;
  }

  modal.hidden = true;
  modal.setAttribute('aria-hidden', 'true');

  document.documentElement.classList.remove(
    QUICK_VIEW_OPEN_CLASS
  );

  if (modal._mkcustomTrigger) {
    modal._mkcustomTrigger.focus();
    modal._mkcustomTrigger = null;
  }
}


/* ==========================================================
   Quick View
========================================================== */

function openQuickView(product, trigger) {

  const modal = createQuickViewModal();

  const images = normalizeProductImages(product);
  const bullets = normalizeShortDescription(product);

  let activeImageIndex = 0;


  /*
  * Preload gallery images so arrow navigation
  * responds immediately after the modal opens.
  */
  images.forEach(function (imageUrl) {
    const preloadImage = new Image();
    preloadImage.src = imageUrl;
  });

  const image = modal.querySelector(
    '[data-mkcustom-cart-quick-view-image]'
  );

  const media = modal.querySelector(
    '.mkcustom-cart-quick-view__media'
  );

  const saleBadge = modal.querySelector(
    '[data-mkcustom-cart-quick-view-sale]'
  );

  const previousButton = modal.querySelector(
    '[data-mkcustom-cart-quick-view-previous]'
  );

  const nextButton = modal.querySelector(
    '[data-mkcustom-cart-quick-view-next]'
  );

  const brand = modal.querySelector(
    '[data-mkcustom-cart-quick-view-brand]'
  );

  const title = modal.querySelector(
    '[data-mkcustom-cart-quick-view-title]'
  );

  const sku = modal.querySelector(
    '[data-mkcustom-cart-quick-view-sku]'
  );

  const price = modal.querySelector(
    '[data-mkcustom-cart-quick-view-price]'
  );

  const comparePrice = modal.querySelector(
    '[data-mkcustom-cart-quick-view-compare]'
  );

  const savings = modal.querySelector(
    '[data-mkcustom-cart-quick-view-savings]'
  );

  const stock = modal.querySelector(
    '[data-mkcustom-cart-quick-view-stock]'
  );

  const bulletList = modal.querySelector(
    '[data-mkcustom-cart-quick-view-bullets]'
  );

  const addButton = modal.querySelector(
    '[data-mkcustom-cart-quick-view-add]'
  );

  function updateImage() {
    const currentImage = images[activeImageIndex] || '';

    if (currentImage && image.src !== currentImage) {
      image.src = currentImage;
    }

    image.alt = product.title || '';

    const hasMultipleImages = images.length > 1;

    previousButton.hidden = !hasMultipleImages;
    nextButton.hidden = !hasMultipleImages;
  }

  previousButton.onclick = function () {
    activeImageIndex =
      (activeImageIndex - 1 + images.length) %
      images.length;

    updateImage();
  };

  nextButton.onclick = function () {
    activeImageIndex =
      (activeImageIndex + 1) %
      images.length;

    updateImage();
  };

/*
 * Mobile Quick View image swipe navigation.
 *
 * Swipe left  = next image
 * Swipe right = previous image
 *
 * Gallery arrow taps are excluded from swipe handling.
 */
let touchStartX = 0;
let touchStartY = 0;
let touchStartedOnControl = false;

if (media) {
  media.ontouchstart = function (event) {
    if (
      !window.matchMedia('(max-width: 749px)').matches ||
      !event.touches.length
    ) {
      return;
    }

    touchStartedOnControl = Boolean(
      event.target.closest(
        '.mkcustom-cart-quick-view__gallery-control'
      )
    );

    if (touchStartedOnControl) {
      return;
    }

    touchStartX = event.touches[0].clientX;
    touchStartY = event.touches[0].clientY;
  };

  media.ontouchend = function (event) {
    if (touchStartedOnControl) {
      touchStartedOnControl = false;
      return;
    }

    if (
      !window.matchMedia('(max-width: 749px)').matches ||
      !event.changedTouches.length ||
      images.length <= 1
    ) {
      return;
    }

    const touchEndX = event.changedTouches[0].clientX;
    const touchEndY = event.changedTouches[0].clientY;

    const horizontalDistance =
      touchEndX - touchStartX;

    const verticalDistance =
      touchEndY - touchStartY;

    if (
      Math.abs(horizontalDistance) < 50 ||
      Math.abs(horizontalDistance) <=
        Math.abs(verticalDistance)
    ) {
      return;
    }

    if (horizontalDistance < 0) {
      activeImageIndex =
        (activeImageIndex + 1) %
        images.length;

      updateImage();
      return;
    }

    activeImageIndex =
      (activeImageIndex - 1 + images.length) %
      images.length;

    updateImage();
  };
}

  brand.textContent = product.brand || '';

  title.textContent = product.title || '';

  sku.textContent = product.sku
    ? 'SKU: ' + product.sku
    : '';

  price.textContent = product.price || '';

  comparePrice.textContent =
    product.onSale && product.comparePrice
      ? 'Was ' + product.comparePrice
      : '';

  comparePrice.hidden =
    !product.onSale || !product.comparePrice;

  const savingsAmount = calculateSavings(product);

  savings.textContent = savingsAmount
    ? 'SAVE ' + savingsAmount
    : '';

  savings.hidden = !savingsAmount;

  stock.textContent = product.available
    ? '✓ In Stock'
    : 'Out of Stock';

  stock.classList.toggle(
    'is-unavailable',
    !product.available
  );

bulletList.innerHTML = '';

bullets.forEach(function (bullet) {
  const item = document.createElement('li');
  item.textContent = bullet;
  bulletList.appendChild(item);
});

bulletList.hidden = false;
bulletList.style.display = bullets.length ? '' : 'none';

  addButton.disabled = !product.available;

  addButton.textContent = product.available
    ? '+ Add to Cart'
    : 'Out of Stock';

  addButton.onclick = function () {
    addProduct(product, addButton);
  };

  updateImage();
  saleBadge.hidden = !product.onSale;

  modal._mkcustomTrigger = trigger || null;

  modal.hidden = false;
  modal.setAttribute('aria-hidden', 'false');

  document.documentElement.classList.add(
    QUICK_VIEW_OPEN_CLASS
  );

  window.requestAnimationFrame(function () {
    modal
      .querySelector(
        '[data-mkcustom-cart-quick-view-close]'
      )
      .focus();
  });
}
  function addProduct(product, button) {
    if (!product || !product.variantId) {
      return;
    }

    if (button.dataset.loading === 'true') {
      return;
    }

    const originalLabel = button.textContent;

    button.dataset.loading = 'true';
    button.disabled = true;
    button.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        id: product.variantId,
        quantity: 1
      })
    })
      .then(function (response) {
        return response.json().then(function (data) {
          return {
            ok: response.ok,
            data: data
          };
        });
      })
      .then(function (result) {
        if (!result.ok || result.data.status) {
          throw new Error(
            result.data.description ||
              result.data.message ||
              'Unable to add this product.'
          );
        }

        button.textContent = 'Added';

        window.setTimeout(function () {
          window.location.reload();
        }, 500);
      })
      .catch(function (error) {
        console.error(
          'MK Cart Line Recommendations:',
          error
        );

        button.dataset.loading = 'false';
        button.disabled = false;
        button.textContent = originalLabel;

        window.alert(
          error.message ||
            'Unable to add this item. Please try again.'
        );
      });
  }

  function createCard(product) {
    const card = createElement(
      'article',
      'mkcustom-cart-line-rec-card'
    );

    card.dataset.variantId = String(
      product.variantId || ''
    );

    card.dataset.sku = String(product.sku || '');

    /*
 * Show a Sale badge only when the product has
 * a valid compare-at price above its selling price.
 */
if (product.onSale && product.comparePrice) {
  const saleBadge = createElement(
    'span',
    'mkcustom-cart-line-rec-card__sale-badge',
    'Sale'
  );

  card.appendChild(saleBadge);
}

const imageLink = createElement(
  'a',
  'mkcustom-cart-line-rec-card__media'
);

imageLink.href = '#';

imageLink.setAttribute(
  'aria-label',
  'View details for ' + (product.title || 'this product')
);

imageLink.addEventListener('click', function (event) {
  event.preventDefault();
  openQuickView(product, imageLink);
});

    const image = createElement(
      'img',
      'mkcustom-cart-line-rec-card__image'
    );

    image.src = product.image || '';
    image.alt = product.title || '';
    image.loading = 'lazy';
    image.decoding = 'async';

    imageLink.appendChild(image);
    card.appendChild(imageLink);

    const content = createElement(
    'div',
    'mkcustom-cart-line-rec-card__content'
    );

    /*
    * Brand
    */
    if (product.brand) {
    const brand = createElement(
        'div',
        'mkcustom-cart-line-rec-card__brand',
        product.brand
    );

    content.appendChild(brand);
    }

/*
 * Product title
 */
const title = createElement(
  'a',
  'mkcustom-cart-line-rec-card__title',
  product.title || ''
);

title.href = '#';

title.setAttribute(
  'aria-label',
  'View details for ' + (product.title || 'this product')
);

title.addEventListener('click', function (event) {
  event.preventDefault();
  openQuickView(product, title);
});

content.appendChild(title);

const pricing = createElement(
  'div',
  'mkcustom-cart-line-rec-card__pricing'
);

    pricing.appendChild(
      createElement(
        'span',
        'mkcustom-cart-line-rec-card__price',
        product.price || ''
      )
    );

    if (product.onSale && product.comparePrice) {
      pricing.appendChild(
        createElement(
          'span',
          'mkcustom-cart-line-rec-card__compare',
          product.comparePrice
        )
      );
    }

    content.appendChild(pricing);

    const button = createElement(
      'button',
      'mkcustom-cart-line-rec-card__button',
      '+ Add'
    );

    button.type = 'button';

    button.addEventListener('click', function () {
      addProduct(product, button);
    });

    content.appendChild(button);
    card.appendChild(content);

    return card;
  }

  function hideModule(module) {
    module.hidden = true;
    module.classList.remove('is-loading', 'is-ready');
    module.classList.add('is-empty');
  }

function initializeCarousel(module, grid) {
  const previousButton = module.querySelector(
    '[data-mkcustom-cart-line-rec-prev]'
  );

  const nextButton = module.querySelector(
    '[data-mkcustom-cart-line-rec-next]'
  );

  const controls = module.querySelector(
    '.mkcustom-cart-line-rec__controls'
  );

  /*
   * Hide navigation when every rendered card already fits
   * inside the visible carousel area.
   *
   * This automatically adapts if the CSS later changes from
   * 5 cards to 6 cards, 3 cards to 2 cards, or any other layout.
   */
  function updateControls() {
    if (!previousButton || !nextButton) {
      return;
    }

    const overflowTolerance = 4;

    const hasScrollableOverflow =
      grid.scrollWidth > grid.clientWidth + overflowTolerance;

    if (controls) {
      controls.hidden = !hasScrollableOverflow;
    } else {
      previousButton.hidden = !hasScrollableOverflow;
      nextButton.hidden = !hasScrollableOverflow;
    }
  }

    function getScrollAmount() {
      const card = grid.querySelector(
        '.mkcustom-cart-line-rec-card'
      );

      if (!card) {
        return grid.clientWidth * 0.8;
      }

      const styles = window.getComputedStyle(grid);
      const gap = parseFloat(
        styles.columnGap || styles.gap || 0
      );

      return card.getBoundingClientRect().width + gap;
    }

  if (previousButton) {
    previousButton.addEventListener('click', function () {
      grid.scrollBy({
        left: -getScrollAmount(),
        behavior: 'smooth'
      });
    });
  }

  if (nextButton) {
    nextButton.addEventListener('click', function () {
      grid.scrollBy({
        left: getScrollAmount(),
        behavior: 'smooth'
      });
    });
  }

  /*
   * Wait until the cards have been rendered and measured.
   */
window.requestAnimationFrame(function () {
  updateControls();

  window.requestAnimationFrame(function () {
    updateControls();
  });
});

  /*
   * Recheck whenever the carousel changes size.
   */
  if ('ResizeObserver' in window) {
    const resizeObserver = new ResizeObserver(function () {
      updateControls();
    });

    resizeObserver.observe(grid);
  } else {
    window.addEventListener('resize', updateControls);
  }
}
function initializeToggle(module, startExpanded) {
  const toggleButton = module.querySelector(
    '[data-mkcustom-cart-line-rec-toggle]'
  );

  const viewport = module.querySelector(
    '[data-mkcustom-cart-line-rec-viewport]'
  );

  const chevron = module.querySelector(
    '.mkcustom-cart-line-rec__chevron'
  );

  if (!toggleButton || !viewport) {
    return;
  }

  /*
  * Initial recommendation state.
  *
  * Desktop / Tablet:
  * - Recommendations start expanded.
  *
  * Mobile:
  * - First recommendation starts expanded.
  * - Remaining recommendations start collapsed.
  */
  const shouldStartExpanded =
    startExpanded !== false;

  toggleButton.setAttribute(
    'aria-expanded',
    shouldStartExpanded ? 'true' : 'false'
  );

  viewport.hidden = !shouldStartExpanded;

  module.classList.toggle(
    'is-expanded',
    shouldStartExpanded
  );

  module.classList.toggle(
    'is-collapsed',
    !shouldStartExpanded
  );

  if (chevron) {
    chevron.textContent =
      shouldStartExpanded ? '▼' : '▶';
  }

  toggleButton.addEventListener('click', function () {
    const isExpanded =
      toggleButton.getAttribute('aria-expanded') === 'true';

    toggleButton.setAttribute(
      'aria-expanded',
      isExpanded ? 'false' : 'true'
    );

    viewport.hidden = isExpanded;

    module.classList.toggle('is-expanded', !isExpanded);
    module.classList.toggle('is-collapsed', isExpanded);

    if (chevron) {
      chevron.textContent = isExpanded ? '▶' : '▼';
    }
  });
}
  function initializeModule(module, startExpanded) {
    if (
      !module ||
      module.dataset.mkcustomLineRecInitialized === 'true'
    ) {
      return;
    }

    module.dataset.mkcustomLineRecInitialized = 'true';
    module.classList.add('is-loading');

    initializeToggle(
      module,
      startExpanded
    );

    const data = readModuleData(module);
    const grid = module.querySelector(GRID_SELECTOR);

    if (!data || !grid) {
      hideModule(module);
      return;
    }

    const candidateSkus = buildCandidateSkus(data);

    if (!candidateSkus.length) {
      hideModule(module);
      return;
    }

    Promise.allSettled(
      candidateSkus.map(fetchProductBySku)
    ).then(function (results) {
      const cartSkuSet = new Set(
        (data.cartSkus || [])
          .map(normalizeSku)
          .filter(Boolean)
      );

      const seenVariantIds = new Set();

      const products = results
        .filter(function (result) {
          return result.status === 'fulfilled' && result.value;
        })
        .map(function (result) {
          return result.value;
        })
        .filter(function (product) {
          if (!product || !product.available) {
            return false;
          }

          if (
            Number(product.inventoryQuantity || 0) <= 0
          ) {
            return false;
          }

          if (
            cartSkuSet.has(normalizeSku(product.sku))
          ) {
            return false;
          }

          const variantId = String(
            product.variantId || ''
          );

          if (
            !variantId ||
            seenVariantIds.has(variantId)
          ) {
            return false;
          }

          seenVariantIds.add(variantId);

          return true;
        });

      if (!products.length) {
        hideModule(module);
        return;
      }

      grid.innerHTML = '';

      products.forEach(function (product) {
        grid.appendChild(createCard(product));
      });

      initializeCarousel(module, grid);

      module.hidden = false;
      module.classList.remove('is-loading', 'is-empty');
      module.classList.add('is-ready');
    });
  }

  function initializeAll(root) {
    const searchRoot = root || document;

    const modules = Array.from(
      searchRoot.querySelectorAll(MODULE_SELECTOR)
    );

    const isMobile =
      window.matchMedia('(max-width: 749px)').matches;

    modules.forEach(function (module, index) {
      /*
      * Desktop / Tablet:
      * All recommendation modules start open.
      *
      * Mobile:
      * Only the first recommendation module starts open.
      */
      const startExpanded =
        !isMobile || index === 0;

      initializeModule(
        module,
        startExpanded
      );
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initializeAll(document);
  });

document.addEventListener(
  'shopify:section:load',
  function (event) {
    initializeAll(event.target);
  }
);

/*
 * Shopify replaces the cart-item HTML after quantity changes.
 * Reinitialize all newly rendered recommendation modules.
 */
document.addEventListener(
  'on:line-item:change',
  function () {
    window.requestAnimationFrame(function () {
      initializeAll(document);
    });
  }
);

})();